// Converte a data passada como parâmetro para o formato "00/00/0000"
/**
 * @param {Date} date - Data (0000-00-00)
 */
export function convertDate(date) {
  if (date !== null && date !== '' && date !== undefined) {
    let dataSplit = date.split('-')

    let day = dataSplit[2]
    let month = dataSplit[1]
    let year = dataSplit[0]

    day = day.substring(0, 2)

    return day + '/' + month + '/' + year
  } else {
    return ''
  }
}

/* Retorna a diferença de dias entre a data atual e a data passada como parâmetro */
/**
 * @param {Date} date - Data (00-00-0000)
 */
export function diffDays(date) {
  if (date != null) {
    let now = new Date() // Data de hoje

    // data passada por parametro
    let dataSplit = date.split('-')
    let day = dataSplit[2]
    let month = dataSplit[1]
    let year = dataSplit[0]
    let date1 = new Date(year, month - 1, day)

    let timeDiff = Math.abs(now.getTime() - date1.getTime())
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

    return parseInt(diffDays)
  }
}

// Calcula o valor da coluna meta na tabela da secretaria de saúde dos indicadores APS
/**
 * @param {int} ministerio_da_saude_no_municipio_denominador - Denominador no município (Ministério da saúde)
 * @param {int} secretaria_municipal_de_saude_no_municipio_denominador - Denominador no município (Secretaria de saúde)
 * @param {int} secretaria_municipal_de_saude_no_municipio_numerador - Numerador no município (Secretaria de saúde)
 * @param {int} indicador - indicador referente ao card
 */
export function calcularMetaNoMunicipio(
  ministerio_da_saude_no_municipio_denominador,
  secretaria_municipal_de_saude_no_municipio_denominador,
  secretaria_municipal_de_saude_no_municipio_numerador,
  indicador
) {
  let meta = 0
  let maior = 0
  let semanas = 0
  let diferenca_de_dias = 0
  if (
    parseInt(ministerio_da_saude_no_municipio_denominador) >
    parseInt(secretaria_municipal_de_saude_no_municipio_denominador)
  ) {
    maior = ministerio_da_saude_no_municipio_denominador
  } else {
    maior = secretaria_municipal_de_saude_no_municipio_denominador
  }
  let data_atual = new Date()
  let dia_atual = data_atual.getDate()
  let mes_atual = data_atual.getMonth() // 0-11 (zero=janeiro)
  let ano_atual = data_atual.getFullYear()
  let mes = mes_atual + 1
  if (mes <= 4) {
    diferenca_de_dias = diffDays(ano_atual + '-04-30')
    semanas = diferenca_de_dias / 7
  } else if (mes > 4 && mes <= 8) {
    diferenca_de_dias = diffDays(ano_atual + '-08-31')
    semanas = diferenca_de_dias / 7
  } else if (mes > 8 && mes <= 12) {
    diferenca_de_dias = diffDays(ano_atual + '-12-31')
    semanas = diferenca_de_dias / 7
  } else {
    diferenca_de_dias = 0
  }
  if (parseInt(semanas) < 1) {
    semanas = 1
  }
  // (MAIOR - NUMERADOR) * % INDICADOR  / SEMANAS
  meta =
    ((maior - secretaria_municipal_de_saude_no_municipio_numerador) *
      indicador) /
    semanas
  return Math.ceil(meta)
}

/**
 * @param {int} ministerio_da_saude_na_equipe_denominador - Denominador na equipe (Ministério da saúde)
 * @param {int} secretaria_municipal_de_saude_na_equipe_denominador - Denominador na equipe (Secretaria de saúde)
 * @param {int} secretaria_municipal_de_saude_na_equipe_numerador - Numerador na equipe (Secretaria de saúde)
 * @param {int} indicador - indicador referente ao card
 */
export function calcularMetaNaEquipe(
  ministerio_da_saude_na_equipe_denominador,
  secretaria_municipal_de_saude_na_equipe_denominador,
  secretaria_municipal_de_saude_na_equipe_numerador,
  indicador
) {
  let meta = 0
  let maior = 0
  let semanas = 0
  let diferenca_de_dias = 0
  if (
    parseInt(ministerio_da_saude_na_equipe_denominador) >
    parseInt(secretaria_municipal_de_saude_na_equipe_denominador)
  ) {
    maior = ministerio_da_saude_na_equipe_denominador
  } else {
    maior = secretaria_municipal_de_saude_na_equipe_denominador
  }
  let data_atual = new Date()
  let dia_atual = data_atual.getDate()
  let mes_atual = data_atual.getMonth() // 0-11 (zero=janeiro)
  let ano_atual = data_atual.getFullYear()
  let mes = mes_atual + 1
  if (mes <= 4) {
    diferenca_de_dias = diffDays(ano_atual + '-04-30')
    semanas = diferenca_de_dias / 7
  } else if (mes > 4 && mes <= 8) {
    diferenca_de_dias = diffDays(ano_atual + '-08-31')
    semanas = diferenca_de_dias / 7
  } else if (mes > 8 && mes <= 12) {
    diferenca_de_dias = diffDays(ano_atual + '-12-31')
    semanas = diferenca_de_dias / 7
  } else {
    diferenca_de_dias = 0
  }
  if (parseInt(semanas) < 1) {
    semanas = 1
  }
  // (MAIOR - NUMERADOR) * % INDICADOR  / SEMANAS
  meta =
    ((maior - secretaria_municipal_de_saude_na_equipe_numerador) * indicador) /
    semanas
  return Math.ceil(meta)
}

/**
 * @param {int} secretaria_municipal_de_saude_no_acs_denominador - Denominador no acs (Secretaria de saúde)
 * @param {int} secretaria_municipal_de_saude_no_acs_numerador - Numerador no acs (Secretaria de saúde)
 * @param {int} indicador - indicador referente ao card
 */
export function calcularMetaNoAcs(
  secretaria_municipal_de_saude_no_acs_denominador,
  secretaria_municipal_de_saude_no_acs_numerador,
  indicador
) {
  let meta = 0
  let maior = 0
  let semanas = 0
  let diferenca_de_dias = 0
  maior = secretaria_municipal_de_saude_no_acs_denominador
  let data_atual = new Date()
  let dia_atual = data_atual.getDate()
  let mes_atual = data_atual.getMonth() // 0-11 (zero=janeiro)
  let ano_atual = data_atual.getFullYear()
  let mes = mes_atual + 1
  if (mes <= 4) {
    diferenca_de_dias = diffDays(ano_atual + '-04-30')
    semanas = diferenca_de_dias / 7
  } else if (mes > 4 && mes <= 8) {
    diferenca_de_dias = diffDays(ano_atual + '-08-31')
    semanas = diferenca_de_dias / 7
  } else if (mes > 8 && mes <= 12) {
    diferenca_de_dias = diffDays(ano_atual + '-12-31')
    semanas = diferenca_de_dias / 7
  } else {
    diferenca_de_dias = 0
  }
  if (parseInt(semanas) < 1) {
    semanas = 1
  }
  // (MAIOR - NUMERADOR) * % INDICADOR  / SEMANAS
  meta =
    ((maior - secretaria_municipal_de_saude_no_acs_numerador) * indicador) /
    semanas
  return Math.ceil(meta)
}
